<div class="breadcrumb-box" *ngIf="notHome">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <a class="accessibility" aria-label="Ir a la página principal" [routerLink]="'/'">
                                <i class="bi bi-house-fill home-icon"></i>
                            </a>
                        </li>
                        <li class="breadcrumb-item" *ngFor="let breadcrumb of breadcrumbs; let last = last" [class.active]="last">
                            <a *ngIf="!last" [routerLink]="breadcrumb.path">{{ breadcrumb.label }}</a>
                            <span *ngIf="last">{{ breadcrumb.label }}</span>
                          </li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
</div>